import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Input,
  Button,
  Spinner,
} from "reactstrap";
import QRCode from "react-qr-code";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import widgetImage from "../../../assets/images/icons-component/image.png";
import Image_not_found from "../../../assets/images/Image_not_found.png";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, imageSrc, openOption, onUpdate, actionEnd, fitToImage, setFitToImage } = props;
  const itemRef = useRef<any>(null);
  const inputRef = useRef<any>(null);
  const [QRcode, setQRcode] = useState<string>("");
  const [Status, setStatus] = useState<any>("0");
  const [uploadImage, setUploadImage] = useState<string>("");

  useEffect(() => {
    if (Status === "2") {
      setTimeout(() => {
        setStatus("1");
      }, 1000);
    }
    
  }, [Status]);

  useEffect(() => {
    if (imageSrc.length !== 0) {
      setUploadImage(imageSrc);
      setStatus("1");
    }
  }, [imageSrc]);

  const handleImageError = (e: any) => {
    e.target.src = Image_not_found;
  }

  const BASE_URL = `${process.env.REACT_APP_API_URL}/elements/image/`;

  return (
    <React.Fragment>
      <div className=" overflow-hidden" style={{ height: '100%', width: '100%', position: 'absolute', transform: `rotateZ(${ config.data?.rotate * 5 }deg)` }}>
        {Status === "1" && uploadImage !== ""? (
          <div className="image-box" ref={itemRef}>
            <img
              src={BASE_URL + uploadImage}
              alt=""
              onError={(e: any) => handleImageError(e)}
              onLoad={(e) => {
                if (fitToImage) {
                  const img = e.currentTarget;
                  const aspectRatio = img.naturalHeight / img.naturalWidth;
                  const calculatedHeight = 400 * aspectRatio;
                  onUpdate({
                    id: config.id,
                    baseHeight: calculatedHeight,
                    height: calculatedHeight,
                    width: 400
                  });
                  actionEnd(true);
                  setFitToImage(false);
                }
              }}
            />
          </div>
        ) : (
          <div className="relative flex h-full flex-col items-center justify-center p-6 bg-screen" style={{ cursor: 'auto', borderRadius: '0.5rem' }}>
            <div className="widget-head">
              <img className="widget-img-icon" src={widgetImage} alt="" />
            </div>
            <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">圖片</p>
            <Button
              color="light"
              className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
              onClick={(e: any) => {openOption();}}
              data-interaction-target-type="false"
            >
              <div className="relative justify-center h-100 w-100">
                <span className="flex items-center justify-center w-100">
                  上傳
                </span>
              </div>
            </Button>
            {username !== config.studentName? (
              <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
            ) : null}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default memo(Index);